import {
	AirlineStore,
	AirportStore,
	IAirline,
	IAirport,
	IFlightEnricher,
} from '@move-frontend/dap';
import { IEnrichedFlightProps } from '../models/IEnrichedFlight';
import { IFlight } from '../models/IFlight';

export function createFlightEnrichers(
	airlineStore: AirlineStore,
	airportStore: AirportStore,
) {
	const airlineEnricher: IFlightEnricher<IFlight, IEnrichedFlightProps> = (
		flight: IFlight,
	) => {
		const airlineDetails = airlineStore.airlines.find(
			(airline: IAirline) => airline.icao === flight.icaoOperatingAirline,
		);

		return {
			...flight,
			airlineDetails,
		};
	};

	const airportEnricher: IFlightEnricher<IFlight, IEnrichedFlightProps> = (
		flight: IFlight,
	) => {
		const { departureAirport, arrivalAirport, baseAirport, viaAirport } =
			flight;

		const departureAirportDetails = airportStore.airports.find(
			(airport: IAirport) => airport.iata === departureAirport,
		);
		const arrivalAirportDetails = airportStore.airports.find(
			(airport: IAirport) => airport.iata === arrivalAirport,
		);
		const baseAirportDetails = airportStore.airports.find(
			(airport: IAirport) => airport.iata === baseAirport,
		);
		const viaAirportDetails = airportStore.airports.find(
			(airport: IAirport) => airport.iata === viaAirport,
		);

		return {
			...flight,
			departureAirportDetails,
			arrivalAirportDetails,
			baseAirportDetails,
			viaAirportDetails,
		};
	};

	return {
		airlineEnricher,
		airportEnricher,
	};
}
